import styled, { css } from 'styled-components'

const RecommendedTag = () => {
  return <StyledWrapper>추천</StyledWrapper>
}

export default RecommendedTag

const StyledWrapper = styled.span`
  ${({ theme }) => css`
    width: 32px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 2px 0;
    border: 1px solid ${theme.color.secondary_1};
    border-radius: 3px;
    margin-right: 5px;
    color: ${theme.color.secondary_1};
    font-size: 11px;
    font-weight: bold;
    vertical-align: top;
  `}
`
